<template lang="pug">
#bloco-inserir-dados-rastreabilidade-planilha
    h1 {{ $t('mensagens.relatorioRastreabilidade.cadastro.preencherRelatorioLote') }}
    el-card
        .box-card-inserir-dados-planilha
            .box-card-inserir-dados-planilha__conteudo
                .box-card-inserir-dados-planilha__conteudo__bloco
                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.paraAgilizarProcessoAdicionarImoveisPlanilha') }}

                .box-card-inserir-dados-planilha__conteudo__bloco
                    .box-card-inserir-dados-planilha__conteudo__bloco__lista
                        // ul
                            li CAR
                            li Volume
                            li CPF/CNPJ
                            li CICLO/ANO

                    .box-card-inserir-dados-planilha__conteudo__bloco__upload
                        .box-card-inserir-dados-planilha__conteudo__bloco__buttons
                            span.btn-download(
                                @click='downloadPlanilhaExemplo()'
                            )
                                i.mdi.mdi-download
                                span {{ $t('mensagens.relatorioRastreabilidade.cadastro.baixarModeloPlanilha') }}

                            el-button(
                                @click='verificarCamposParaEnviarPlanilha',
                                :icon='loadingUpload ? "el-icon-loading" : "el-icon-upload2"',
                                type='primary'
                            ) {{ loadingUpload ? '' : $t('mensagens.relatorioRastreabilidade.cadastro.inserirPlanilha') }}

                            el-upload.upload-demo-lote(
                                action='#',
                                :auto-upload='false',
                                :show-file-list='false',
                                :on-change='enviarPlanilha',
                                :on-exceed='onExceed',
                                :limit='1',
                                ref='uploadPlanilhaTerritorio'
                            )
                                span
                                    el-button(
                                        :icon='loadingUpload ? "el-icon-loading" : "el-icon-upload2"',
                                        type='primary'
                                    ) {{ loadingUpload ? '' : 'Inserir planilha' }}

                div(v-if='dadosElegibilidadePlanilha.length')
                    hr
                    .bloco-inserir-contrato-originacao-planilha-lote-importada
                        .bloco-inserir-contrato-originacao-planilha-lote-importada__header
                            el-checkbox(
                                v-model='selecionarTodosItensEmMassa',
                                @change='handleSelecionarTodosItensEmMassa'
                            ) {{ $t('mensagens.relatorioRastreabilidade.cadastro.selecionarTodos') }}

                            .select-alinhar-dados-lote
                                span {{ $t('mensagens.relatorioRastreabilidade.cadastro.visualizarPorAnalise') }}:
                                el-select(
                                    v-model='selecionadoOpcoesVisualizarElegibilidade',
                                    multiple,
                                    collapse-tags,
                                    :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.todos")'
                                )
                                    el-option(
                                        v-for='item in opcoesVisualizarElegibilidade',
                                        :key='item.value',
                                        :label='item.label',
                                        :value='item.value'
                                    )

                        .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo
                            .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item(
                                v-for='(item, i) in listaLoteElegibilidade',
                                :key='i'
                            )
                                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda
                                    .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__cima
                                        el-checkbox(
                                            v-model='item.remover',
                                            :label='item.car',
                                            :key='i',
                                            @change='handleSelecionarItens'
                                        ) CAR: {{ item.car }}

                                        .analise-elegibilidade-span
                                            span.strong-elegibilidade {{ $t('mensagens.relatorioRastreabilidade.cadastro.analiseElegibilidade') }}:
                                            .analise-elegibilidade-span__resultado
                                                i.flow.flow-warning-sign(
                                                    :class='corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].classeCor : ""'
                                                )
                                                span(
                                                    :class='corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].classeCor : ""'
                                                ) {{ corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].status : '' }}

                                    .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__baixo
                                        .resultado(
                                            :class='corStatus[item.analiseElegibilidade] ? corStatus[item.analiseElegibilidade].bloco : ""'
                                        )
                                            .resultado-diagnostico
                                                span {{ $t('mensagens.relatorioRastreabilidade.cadastro.diagnosticoSocioambiental') }}:
                                                |
                                                span(
                                                    :class='statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade] ? statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade].corClasse : ""'
                                                ) {{ statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade] ? statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade].status : '' }}

                                            .resultado-capacidade-produtiva
                                                span {{ $t('mensagens.relatorioRastreabilidade.cadastro.capacidadeProdutiva') }}:
                                                |
                                                span(
                                                    :class='statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade] ? statusDiagnostico[item.diagnosticoSocioambiental.nivelAlertaRastreabilidade].corClasse : ""'
                                                ) {{ item.saldo.saldoCar?.capacidadeProdutiva }} t

                                            .resultado-saldo
                                                // span Saldo disponível:
                                                    |
                                                    span(
                                                        :class='item.saldo.saldoCar.saldoCARcapacidadeProdutiva <= 0 ? "status-danger" : "status-sucess"'
                                                    ) {{ item.saldo.saldoCar.saldoCARcapacidadeProdutiva }} ({{ item.saldo.saldoCar.calculoSaca.saldoCARcapacidadeProdutivaSaca }} sc)

                                            // .resultado-distancia
                                                span Distância:
                                                |
                                                span(
                                                    :class='item.municipioContrato.distancia > limiteRaio ? "status-danger" : "status-sucess"'
                                                ) {{ item.municipioContrato.distancia }} km

                                            .resultado__link-detalhar.strong-elegibilidade
                                                span(
                                                    @click='verDetalhesElegibilidade(item)'
                                                ) {{ $t('mensagens.comuns.verDetalhes') }}
                                                i.mdi.mdi-arrow-right

                                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__direita
                                    el-form(@submit.native.prevent)
                                        el-form-item(
                                            :label='$t("mensagens.relatorioRastreabilidade.cadastro.volumeT")'
                                        )
                                            el-input(
                                                v-model.prevent='item.volume',
                                                @blur='volumeRecebidoFormatado(i)'
                                            )

                            .listagem-vazia(
                                v-if='!listaLoteElegibilidade.length && dadosElegibilidadePlanilha.length'
                            )
                                p {{ $t('mensagens.relatorioRastreabilidade.cadastro.semDadosPeloFiltro') }}

                        .bloco-inserir-contrato-originacao-planilha-lote-importada__footer
                            .remover-item-lista(
                                @click='removerListaAnaliseElegibilidade'
                            )
                                i.el-icon-delete
                                | {{ $t('mensagens.relatorioRastreabilidade.cadastro.removerItem') }}
                            .volume-total-lista
                                span {{ $t('mensagens.relatorioRastreabilidade.cadastro.volumeTotal') }}:
                                    |
                                    |
                                    b {{ formatarTonelada(somaVolumeElegibilidade) }}
                            el-button(
                                type='primary',
                                @click='adicionarListaCar',
                                :loading='loadingProcessamentoPlanilha',
                                :icon='loadingProcessamentoPlanilha ? "el-icon-loading" : "el-icon-plus"'
                            ) {{ loadingProcessamentoPlanilha ? '' : $t('mensagens.relatorioRastreabilidade.cadastro.adicionarLista') }}

    ModalHeaderRastreabilidadeRelatorioEmMassaPlanilha(
        :show='modalHeaderPlanilha',
        :dados='dadosHeader',
        @processarVinculo='processarVinculo',
        @voltar='modalHeaderPlanilha = false',
        :carregando='loadingProcessamentoPlanilha'
    )

    ModalProcessamentoRastreabilidadeRelatorioEmMassaPlanilha(
        :show='modalProcessamentoPlanilha',
        :dados='dadosProcessamentoPlanilha',
        :temError='temErrorDadosProcessamento',
        @analisarImoveis='analisarImoveis',
        @voltar='modalProcessamentoPlanilha = false; modalAlerta = false',
        :carregando='loadingProcessamentoPlanilha',
        :modalAlerta='modalAlerta'
    )

    ModalAnaliseElegibilidadeRelatorio(
        :show='ativarModalAnaliseElegibilidadeDetalhes',
        :dados='dadosAnaliseElegibilidadeDetalhes',
        @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidadeDetalhes = false',
        :idMapa='"mapaAnaliseEleigibilidadeRelatorioLote"'
    )
</template>

<script>
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import ModalHeaderRastreabilidadeRelatorioEmMassaPlanilha from '@/components/relatorioRastreabilidade/ModalHeaderRastreabilidadeRelatorioEmMassaPlanilha.vue';
import ModalProcessamentoRastreabilidadeRelatorioEmMassaPlanilha from '@/components/relatorioRastreabilidade/ModalProcessamentoRastreabilidadeRelatorioEmMassaPlanilha.vue';
import ModalAnaliseElegibilidadeRelatorio from '@/components/relatorioRastreabilidade/ModalAnaliseElegibilidadeRelatorio.vue';
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';

export default {
    name: 'BlocoInserirDadosRastreabilidadePlanilha',
    components: {
        ModalHeaderRastreabilidadeRelatorioEmMassaPlanilha,
        ModalProcessamentoRastreabilidadeRelatorioEmMassaPlanilha,
        ModalAnaliseElegibilidadeRelatorio
    },

    props: {
        dados: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            dadosHeader: [],
            dadosProcessamentoPlanilha: [],
            dadosElegibilidadePlanilha: [],
            temErrorDadosProcessamento: false,
            modalHeaderPlanilha: false,
            modalProcessamentoPlanilha: false,
            loadingProcessamentoPlanilha: false,
            loadingUpload: false,
            selecionarTodosItensEmMassa: false,
            somaVolumeElegibilidade: 0,
            ativarModalAnaliseElegibilidadeDetalhes: false,
            dadosAnaliseElegibilidadeDetalhes: {
                elegibilidade: '',
                safraNome: '',
                cpfCnpj: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            },
            inputVolumeElegibilidade: '',
            planilha: null,
            corStatus: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.elegivel'
                    ),
                    bloco: 'status-bloco-verde'
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inelegivel'
                    ),
                    bloco: 'status-bloco-vermelho'
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: '',
                    bloco: 'status-bloco-cinza'
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.comAlerta'
                    ),
                    bloco: 'status-bloco-laranja'
                }
            },
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.alerta'
                    )
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.alerta'
                    )
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.conforme'
                    )
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inconforme'
                    )
                }
            },
            selecionadoOpcoesVisualizarElegibilidade: [],
            opcoesVisualizarElegibilidade: [
                {
                    value: 'ELEGIVEL',
                    label: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.elegivel'
                    )
                },
                {
                    value: 'ALERTA',
                    label: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.comAlerta'
                    )
                },
                {
                    value: 'INELEGIVEL',
                    label: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inelegivel'
                    )
                }
            ],
            modalAlerta: false
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        listaLoteElegibilidade() {
            if (!this.selecionadoOpcoesVisualizarElegibilidade.length) {
                return this.dadosElegibilidadePlanilha;
            } else {
                return this.dadosElegibilidadePlanilha.filter(item =>
                    this.selecionadoOpcoesVisualizarElegibilidade.includes(
                        item.analiseElegibilidade
                    )
                );
            }
        }
    },
    watch: {
        '$i18n._vm.locale': function () {
            this.updateOpcoesVisualizarElegibilidade();
            this.updateStatusDiagnostico();
            this.updateCorStatus();
        }
    },
    methods: {
        onExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.relatorioRastreabilidade.cadastro.umArquivoPorVez'
                ),
                position: 'top-left'
            });
        },

        verificarCamposParaEnviarPlanilha(planilha) {
            this.$emit('validarCamposDadosRelatorioLote', planilha);
        },

        async enviarPlanilha(planilha) {
            if (this.loadingUpload || this.modalHeaderPlanilha) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.aguardeProcessamentoAndamento'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }
            if (this.dadosElegibilidadePlanilha.length) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.concluaDadosAtuais'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.tamanhoMaximoExcedido'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx') {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.ExtensaoNaoPermitida'
                    )
                });
                this.$refs.uploadPlanilhaTerritorio.clearFiles();
                return false;
            }
            this.planilha = planilha;
            this.loadingUpload = true;
            this.dadosHeader = [];
            try {
                this.$notify.success({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.arquivoSendoEnviado'
                    )
                });
                const { data } =
                    await RelatorioRastreabilidadeService.buscarHeaderPlanilhaUpload(
                        planilha
                    );
                this.dadosHeader = data.cabecalho;
                this.modalHeaderPlanilha = true;
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
            this.$refs.uploadPlanilhaTerritorio.clearFiles();
            this.loadingUpload = false;
        },
        async processarVinculo(campos) {
            this.loadingProcessamentoPlanilha = true;
            try {
                const { data } =
                    await RelatorioRastreabilidadeService.validarPlanilhaTerritorio(
                        campos,
                        this.planilha
                    );

                if (data.erros.length) {
                    this.temErrorDadosProcessamento = true;
                    this.dadosProcessamentoPlanilha = data.erros;
                } else {
                    this.temErrorDadosProcessamento = false;
                    this.dadosProcessamentoPlanilha = data.itens;
                }

                this.modalAlerta = true;
                this.modalProcessamentoPlanilha = true;
                this.modalHeaderPlanilha = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.erroValidarPlanilha'
                    )
                });
            }
            this.loadingProcessamentoPlanilha = false;
        },
        resetarElegibilidade() {
            this.dadosElegibilidadePlanilha = [];
            this.analiseElegibilidade = [];
            this.selecionarTodosItensEmMassa = false;
            this.selecionadoOpcoesVisualizarElegibilidade = [];
        },
        async analisarImoveis() {
            this.modalAlerta = false;
            this.loadingProcessamentoPlanilha = true;
            this.resetarElegibilidade();
            try {
                const territorios = this.dadosProcessamentoPlanilha.map(
                    territorio => {
                        return {
                            codigoCar: territorio.CAR,
                            cpfCnpj: territorio['CPF/CNPJ'],
                            volumeAdicionado: territorio.Volume,
                            anoSafra: parseInt(territorio['CICLO/ANO'])
                        };
                    }
                );

                const dados = {
                    numeroContrato: this.dados.numeroContrato,
                    nomeCultura: this.dados.nomeCultura,
                    idProtocolo: this.dados.idProtocolo,
                    territorios: territorios
                };

                const { data } =
                    await RelatorioRastreabilidadeService.realizarElegibilidadeLote(
                        dados
                    );
                if (!data.territorios.length) {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.semDadosPlanilha'
                        )
                    });

                    this.$emit('bloqueioDeEdicao', false);
                } else {
                    if (data.territorios.find(t => t.erro?.includes('CAR'))) {
                        const erros = [];
                        data.territorios.forEach((t, index) => {
                            if (t.erro) {
                                erros.push({
                                    campo: 'CAR',
                                    linha: index + 1,
                                    mensagem: t.erro
                                });
                            }
                        });

                        this.temErrorDadosProcessamento = true;
                        this.dadosProcessamentoPlanilha = erros;
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.erroProcessamentoCar'
                            )
                        });

                        this.modalAlerta = true;
                        this.modalHeaderPlanilha = false;
                        this.loadingProcessamentoPlanilha = false;
                        return;
                    }
                    data.territorios.forEach((item, index) => {
                        if (!item.hasOwnProperty('remover')) {
                            item.remover = false;
                        }
                        if (!item.hasOwnProperty('analiseElegibilidade')) {
                            item.analiseElegibilidade =
                                this.analisarElegibilidade(item);
                        }
                        this.dadosElegibilidadePlanilha.push(item);
                    });
                    this.calcularToneladaElegibilidade();

                    this.$emit('bloqueioDeEdicao', true);
                }

                this.modalProcessamentoPlanilha = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.erroAoAnalisar'
                    )
                });
            }
            this.loadingProcessamentoPlanilha = false;
        },
        analisarElegibilidade(item) {
            if (
                item.diagnosticoSocioambiental
                    ?.resultadoDiagnosticoRastreabilidade === null
            ) {
                return;
            }

            if (item.saldo?.saldoCar?.saldoCARcapacidadeProdutiva === null) {
                return;
            }
            let resultadoElegibilidade = 'INDEFINIDO';
            if (
                item.diagnosticoSocioambiental
                    .resultadoDiagnosticoRastreabilidade === 'INCONFORME'
            ) {
                resultadoElegibilidade = 'INELEGIVEL';
            } else if (
                item.diagnosticoSocioambiental.nivelAlertaRastreabilidade ===
                'MEDIO_ALTO'
            ) {
                resultadoElegibilidade = 'ALERTA';
            } else {
                resultadoElegibilidade = 'ELEGIVEL';
            }

            if (item.saldo.saldoCar?.saldoCARcapacidadeProdutiva <= 0) {
                resultadoElegibilidade = 'INELEGIVEL';
            }
            return resultadoElegibilidade;
        },
        verDetalhesElegibilidade(item) {
            this.resetModalAnaliseElegibilidadeDetalhes();

            this.dadosAnaliseElegibilidadeDetalhes.dadosBuscaSaldo.codigoCar =
                item.car;
            this.dadosAnaliseElegibilidadeDetalhes.dadosBuscaSaldo.cultura.codigo =
                item.saldo.saldoCar?.cultura.codigo;
            this.dadosAnaliseElegibilidadeDetalhes.safraNome = item.cicloAno;

            this.dadosAnaliseElegibilidadeDetalhes.dadosBuscaSaldo =
                item.saldo.saldoCar;

            this.dadosAnaliseElegibilidadeDetalhes.dadosDiagnostico =
                item.diagnosticoSocioambiental;

            this.dadosAnaliseElegibilidadeDetalhes.cpfCnpj =
                this.formatarCpfCnpj(item.cpfCnpj);

            this.dadosAnaliseElegibilidadeDetalhes.elegibilidade =
                item.analiseElegibilidade;

            this.ativarModalAnaliseElegibilidadeDetalhes = true;
        },
        formatarCpfCnpj(valor) {
            if (
                /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(valor) ||
                /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(valor)
            ) {
                return valor;
            } else {
                return formatters.numeralStringFormatTocpfCnpj(
                    valor.replace(/\D/g, '')
                );
            }
        },
        formatarTonelada(valor) {
            return formatters.formatNumber(valor, 2);
        },
        handleSelecionarTodosItensEmMassa() {
            let valor = true;
            if (this.selecionarTodosItensEmMassa) {
                valor = true;
            } else {
                valor = false;
            }
            this.selecionadoOpcoesVisualizarElegibilidade = [];
            this.dadosElegibilidadePlanilha.forEach(item => {
                item.remover = valor;
            });
        },
        removerListaAnaliseElegibilidade() {
            if (
                !this.dadosElegibilidadePlanilha.some(
                    item => item.remover === true
                )
            ) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.selecioneUmItemParaExcluir'
                    )
                });
                return;
            }
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.confirmarRemocao'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.comuns.cancelar'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.dadosElegibilidadePlanilha =
                            this.dadosElegibilidadePlanilha.filter(item => {
                                return (
                                    !('remover' in item) ||
                                    item.remover === false
                                );
                            });
                        this.calcularToneladaElegibilidade();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.remocaoRealizada'
                            )
                        });

                        if (this.dadosElegibilidadePlanilha.length) {
                            this.$emit('bloqueioDeEdicao', true);
                        } else {
                            this.$emit('bloqueioDeEdicao', false);
                        }
                    })
                    .catch(() => {});
            } catch (erro) {}
        },
        handleSelecionarItens() {
            if (
                this.dadosElegibilidadePlanilha.every(
                    item => item.remover === true
                )
            ) {
                this.selecionarTodosItensEmMassa = true;
            } else {
                this.selecionarTodosItensEmMassa = false;
            }
        },
        volumeRecebidoFormatado(index) {
            this.dadosElegibilidadePlanilha[index].volume =
                formatters.formatarTonelada(
                    this.dadosElegibilidadePlanilha[index].volume
                );
            this.calcularToneladaElegibilidade();
        },
        calcularToneladaElegibilidade() {
            this.somaVolumeElegibilidade = 0;
            if (this.dadosElegibilidadePlanilha.length) {
                this.dadosElegibilidadePlanilha.forEach(item => {
                    let valor = item['volume'];
                    if (typeof valor === 'string') {
                        valor = valor.replace(',', '.');
                    }
                    const numero = parseFloat(valor);
                    if (!isNaN(numero)) {
                        this.somaVolumeElegibilidade += numero;
                    }
                });
            }
        },
        async adicionarListaCar() {
            if (this.loadingProcessamentoPlanilha) {
                return;
            }

            if (!this.dadosElegibilidadePlanilha.length) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.insiraPlanilhaComDados'
                    )
                });
                return;
            }

            let comErroVolume = 0;
            let comErroSaldoCapacidadeProdutiva = 0;
            let somaVolume = 0;
            let dadosListagem = [];
            let mapaCodigoCar = new Map();

            this.dadosElegibilidadePlanilha.forEach(item => {
                if (!item.volume) {
                    comErroVolume++;
                } else {
                    somaVolume += parseFloat(
                        item.volume.toString().replace(',', '.')
                    );
                }
                if (
                    item.volume &&
                    parseFloat(item.volume.toString().replace(',', '.')) >
                        item.saldo.saldoCar?.capacidadeProdutiva
                ) {
                    comErroSaldoCapacidadeProdutiva++;
                } else {
                    dadosListagem.push({
                        anoSafra: item.cicloAno,
                        codigoCar: item.car,
                        cpfCnpj: item.cpfCnpj,
                        idLinha: Math.floor(Math.random() * 1000000),
                        nivelAlerta:
                            item.diagnosticoSocioambiental
                                .nivelAlertaRastreabilidade,
                        resultadoDiagnostico: JSON.stringify(
                            item.diagnosticoSocioambiental
                        ),
                        situacao:
                            item.diagnosticoSocioambiental
                                .resultadoDiagnosticoRastreabilidade,
                        volumeAdicionado: parseFloat(
                            item.volume.toString().replace(',', '.')
                        )
                    });
                }
                // para verificar se há duplicidade do CAR
                let codigoCar = item.car;
                if (mapaCodigoCar.has(codigoCar)) {
                    mapaCodigoCar.set(
                        codigoCar,
                        mapaCodigoCar.get(codigoCar) + 1
                    );
                } else {
                    mapaCodigoCar.set(codigoCar, 1);
                }
            });
            if (comErroVolume > 0) {
                this.$notify.error({
                    message:
                        this.getMensagemCarsVolumeNaoInserido(comErroVolume)
                });
                return;
            }
            if (comErroSaldoCapacidadeProdutiva > 0) {
                this.$notify.error({
                    message:
                        this.getMensagemCarsVolumeExcedeCapacidadeProdutiva(
                            comErroSaldoCapacidadeProdutiva
                        )
                });
                return;
            }

            let temDuplicidade = false;
            mapaCodigoCar.forEach(value => {
                if (value > 1) {
                    temDuplicidade = true;
                }
            });
            if (temDuplicidade) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.carDuplicado'
                    )
                });
                return;
            }

            this.$emit('adicionarListagemLote', dadosListagem, somaVolume);
        },
        downloadPlanilhaExemplo() {
            let link = document.createElement('a');
            link.setAttribute(
                'download',
                'planilha-exemplo-rastreabilidade-em-massa'
            );
            link.href = this.getLinkDownloadPlanilha();
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        resetModalAnaliseElegibilidadeDetalhes() {
            this.dadosAnaliseElegibilidadeDetalhes = {
                elegibilidade: '',
                safraNome: '',
                cpfCnpj: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            };
        },
        limparDadosPlanilha() {
            this.dadosElegibilidadePlanilha = [];
            this.resetModalAnaliseElegibilidadeDetalhes();
            this.$refs.uploadPlanilhaTerritorio.clearFiles();
        },
        updateOpcoesVisualizarElegibilidade() {
            this.opcoesVisualizarElegibilidade.forEach(opcao => {
                if (opcao.value === 'ELEGIVEL') {
                    opcao.label = this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.elegivel'
                    );
                }

                if (opcao.value === 'INELEGIVEL') {
                    opcao.label = this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inelegivel'
                    );
                }

                if (opcao.value === 'ALERTA') {
                    opcao.label = this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.comAlerta'
                    );
                }
            });
        },
        updateStatusDiagnostico() {
            this.statusDiagnostico.BAIXO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.conforme'
            );
            this.statusDiagnostico.MEDIO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.alerta'
            );
            this.statusDiagnostico.MEDIO_ALTO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.alerta'
            );
            this.statusDiagnostico.ALTO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.inconforme'
            );
        },
        updateCorStatus() {
            this.corStatus.ELEGIVEL.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.elegivel'
            );
            this.corStatus.INELEGIVEL.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.inelegivel'
            );
            this.corStatus.ALERTA.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.comAlerta'
            );
        },
        getMensagemCarsVolumeNaoInserido(qtdErros) {
            if (this.$i18n._vm.locale === 'en') {
                const startMessage = qtdErros > 1 ? 'There are' : 'There is';
                return `${startMessage} ( ${qtdErros} ) ${this.$t(
                    'mensagens.relatorioRastreabilidade.cadastro.territoriosComVolumeNaoInserido'
                )}`;
            }

            return `${this.$t(
                'mensagens.relatorioRastreabilidade.cadastro.ha'
            )} ( ${qtdErros} ) ${this.$t(
                'mensagens.relatorioRastreabilidade.cadastro.territoriosComVolumeNaoInserido'
            )}`;
        },
        getMensagemCarsVolumeExcedeCapacidadeProdutiva(qtdErros) {
            if (this.$i18n._vm.locale === 'en') {
                const startMessage = qtdErros > 1 ? 'There are' : 'There is';
                return `${startMessage} ( ${qtdErros} ) ${this.$t(
                    'mensagens.relatorioRastreabilidade.cadastro.territoriosVolumeExcedeCapacidadeProdutiva'
                )}`;
            }

            return `${this.$t(
                'mensagens.relatorioRastreabilidade.cadastro.ha'
            )} ( ${qtdErros} ) ${this.$t(
                'mensagens.relatorioRastreabilidade.cadastro.territoriosVolumeExcedeCapacidadeProdutiva'
            )}`;
        },
        getLinkDownloadPlanilha() {
            const locale = this.$i18n._vm.locale;
            return locale === 'pt-BR'
                ? 'https://lyra-bunge-publico.s3.amazonaws.com/planilha-exemplo-relatorio-em-massa.xlsx'
                : locale === 'es'
                ? 'https://lyra-bunge-publico.s3.amazonaws.com/planilha-exemplo-relatorio-em-massa-espanhol.xlsx'
                : 'https://lyra-bunge-publico.s3.amazonaws.com/planilha-exemplo-relatorio-em-massa-ingles.xlsx';
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-dados-rastreabilidade-planilha {
    width: 100%;

    h1,
    ul {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .lista {
        display: flex;
        flex-direction: row;
    }

    el-card {
        margin-top: 10px;
    }
    .box-card-inserir-dados-planilha__conteudo {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        gap: 15px;

        .box-card-inserir-dados-planilha__conteudo__bloco {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            gap: 15px;
            .box-card-inserir-dados-planilha__conteudo__bloco__upload {
                .el-button.el-button--primary {
                    min-width: 200px;
                }
            }
            .box-card-inserir-dados-planilha__conteudo__bloco__buttons {
                display: flex;
                gap: 15px;
                width: 100%;
                justify-content: flex-end;
                align-items: center;
                .btn-download {
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    font-weight: 600;
                    font-size: 14px;
                    i {
                        font-size: 15px;
                    }
                    span {
                        text-decoration: underline;
                        color: var(--primary);
                    }
                }
            }

            .box-card-inserir-dados-planilha__conteudo__bloco__lista {
                ul {
                    margin-bottom: 15px;
                }
                li::after {
                    content: ' *';
                    color: #f56c6c;
                }
            }
        }
        .listagem-vazia {
            text-align: center;
            margin-top: 30px;
            color: #a4a4a5;
        }
    }
    .bloco-inserir-contrato-originacao-planilha-lote-importada__header {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        .select-alinhar-dados-lote {
            display: flex;
            justify-content: space-between;
            gap: 5px;
            align-items: center;
            border: 1px solid var(--primary);
            border-radius: 5px;
            padding: 0px 11px;
            font-size: 14px;
            input::placeholder {
                color: var(--primary) !important;
            }
            .el-input__inner {
                border: 0px solid var(--primary) !important;
                padding-left: 5px !important;
            }
            .el-select__caret {
                color: var(--primary);
            }
        }
    }
    .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo {
        overflow-y: auto;
        max-height: 500px;

        .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item {
            display: flex;
            justify-content: space-between;
            gap: 10px;
            margin-bottom: 18px;
            .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda {
                display: flex;
                width: 80%;
                flex-direction: column;
                padding-top: 10px;
                .strong-elegibilidade {
                    font-weight: bold;
                }
                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__cima {
                    display: flex;
                    justify-content: flex-start;
                    gap: 20px;
                    font-size: 14px;
                    width: 100%;
                }
                .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__esquerda__baixo {
                    width: 100%;
                    padding-top: 10px;
                    .resultado {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        gap: 8px;
                        padding: 5px;
                        border-radius: 6px;
                        font-size: 14px;
                        align-items: center;
                        min-height: 40px;
                        padding-left: 10px;
                        padding-right: 10px;

                        .resultado__link-detalhar {
                            color: #1989fa;
                            cursor: pointer;
                        }
                        .resultado__link-detalhar:hover {
                            text-decoration: underline;
                        }
                    }
                }

                .analise-elegibilidade-span {
                    display: flex;
                }
            }
            .bloco-inserir-contrato-originacao-planilha-lote-importada__conteudo__item__direita {
                width: 20%;
            }
            .status-amarelo {
                font-weight: bold;
                color: #bfae19;
                font-size: 14px;
                margin-left: 4px;
            }

            .status-laranja {
                font-weight: bold;
                color: var(--warning);
                font-size: 14px;
                margin-left: 4px;
            }

            .status-danger {
                font-weight: bold;
                color: var(--danger);
                font-size: 14px;
                margin-left: 4px;
            }

            .status-sucess {
                font-weight: bold;
                color: var(--green);
                font-size: 14px;
                margin-left: 4px;
            }
            .status-bloco-verde {
                background-color: #3591381a;
            }
            .status-bloco-laranja {
                background-color: #f9935a1a;
            }
            .status-bloco-vermelho {
                background-color: #ec32321a;
            }
            .status-bloco-cinza {
                background-color: #e7e7e7;
            }
        }
    }
    .bloco-inserir-contrato-originacao-planilha-lote-importada__footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        margin-top: 40px;
        .remover-item-lista {
            color: #ec3232;
            cursor: pointer;
            i {
                margin-right: 5px;
            }
        }
        .remover-item-lista:hover {
            text-decoration: underline;
        }

        .el-button {
            min-width: 167px;
        }
    }
    .upload-demo-lote {
        display: none;
    }
}
.notificacao-rastreabilidade-em-massa-lote {
    width: 500px;
}
</style>
